import { render, staticRenderFns } from "./MyStaffReviewForm.vue?vue&type=template&id=38c0ca2c&scoped=true"
import script from "./MyStaffReviewForm.vue?vue&type=script&lang=js"
export * from "./MyStaffReviewForm.vue?vue&type=script&lang=js"
import style0 from "./MyStaffReviewForm.vue?vue&type=style&index=0&id=38c0ca2c&prod&lang=css"
import style1 from "./MyStaffReviewForm.vue?vue&type=style&index=1&id=38c0ca2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0ca2c",
  null
  
)

export default component.exports